import type { ChangeEvent, HTMLInputTypeAttribute, KeyboardEvent } from 'react';

interface TextInputProps {
  value: string;
  onChange: (value: string, event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: HTMLInputTypeAttribute;
  id?: string;
  disabled?: boolean;
  onFocus?: () => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  fullWidth?: boolean;
  size?: 'sm' | 'md';
  testId?: string;
}

const BASE_CLASSNAME =
  'rounded-lg border border-wolisho-brown/20 bg-wolisho-cream px-3 text-black focus:border-wolisho-red focus:outline-hidden';

const SIZE_CLASSNAME = {
  sm: 'py-2 text-sm',
  md: 'py-2.5',
} as const;

export function TextInput({
  value,
  onChange,
  placeholder,
  type = 'text',
  id,
  disabled,
  onFocus,
  onKeyDown,
  fullWidth = false,
  size = 'md',
  testId,
}: TextInputProps) {
  const className = [fullWidth && 'w-full', BASE_CLASSNAME, SIZE_CLASSNAME[size]]
    .filter(Boolean)
    .join(' ');

  return (
    <input
      id={id}
      type={type}
      value={value}
      onChange={(event) => onChange(event.target.value, event)}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      disabled={disabled}
      placeholder={placeholder}
      className={className}
      data-testid={testId}
    />
  );
}
